module.exports = __webpack_public_path__ + "static/media/hamamatsu_button_gochirameru.25f7237f.png";